export const UrlPaths = {
	assets: {
		images: "assets/images",
		custom: { fonts: "assets/custom/fonts" },
		styles: { richTextEditor: "assets/styles/rich-text-editor.css" }
	},
	pages: { fieldInformation: "seiten/feld-information" },
	portal: { internalApplication: { subpath: "antrag" } }
} as const;

export const UrlParameters = {
	marker: "marker"
};
